import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Select from "../../../components/ui/Select";
import { useSelector } from "react-redux";

const UserCarsFormModal = ({
  isOpen,
  onClose,
  onSave,
  item,
  mode,
  language,
}) => {
  const { usersList } = useSelector((state) => state.users);

  const { tagsList } = useSelector((state) => state.workshops);

  const {isLoadingActions}= useSelector((state) => state.general);

  const initialState = {
    user_id: "",
    vehicle_type: "",
    vehicle_model: "",
    vehicle_year: "",
    vehicle_number: "",
    vehicle_brand_id: "",

    vehicle_color: "",
    notes: "",

    oil_name: "",
    oil_rank: "",
    oil_meter_value: "",
    oil_changed_at: "",
    oil_change_center: "",

    tire_name: "",
    tire_type: "",
    tire_change_center: "",
    tire_changed_at: "",

    air_filter_changed_at: "",
    air_filter_center: "",

    oil_filter_changed_at: "",
    cooling_filter_changed_at: "",
    petrol_filter_changed_at: "",

    battery_changed_at: "",
    battery_change_center: "",
    battery_type: "",

    damages_note: "",
  };

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (item) {
      setFormData((prev) => ({ ...prev, ...item }));
    } else {
      setFormData(initialState);
    }
    setErrors({});
  }, [item, isOpen]);

  // ✅ TRANSLATION FULL
  const labels = {
    addTitle: { en: "Add New Car Profile", ar: "إضافة ملف سيارة جديد" },
    editTitle: { en: "Edit Car Profile", ar: "تعديل ملف السيارة" },

    user: { en: "User", ar: "المستخدم" },
    vehicle_type: { en: "Car Type", ar: "نوع السيارة" },
    vehicle_model: { en: "vehicle_model", ar: "الموديل" },
    vehicle_year: { en: "vehicle_year", ar: "السنة" },
    vehicle_number: { en: "License Plate", ar: "لوحة الترخيص" },
    vehicle_brand_id: { en: "vehicle_brand_id", ar: "التفضيلات" },

    vehicleColor: { en: "Color", ar: "اللون" },
    notes: { en: "Notes", ar: "ملاحظات" },

    oilSection: { en: "Oil Info", ar: "معلومات الزيت" },
    oilName: { en: "Oil Name", ar: "اسم الزيت" },
    oilRank: { en: "Oil Rank", ar: "درجة الزيت" },
    oilMeter: { en: "Oil Meter", ar: "عداد الزيت" },
    oilChangedAt: { en: "Changed At", ar: "تاريخ التغيير" },
    oilCenter: { en: "Center", ar: "المركز" },

    tireSection: { en: "Tires", ar: "الإطارات" },
    tireName: { en: "Tire Name", ar: "اسم الإطار" },
    tireType: { en: "Tire Type", ar: "نوع الإطار" },
    tireChangedAt: { en: "Changed At", ar: "تاريخ التغيير" },

    batterySection: { en: "Battery", ar: "البطارية" },
    batteryType: { en: "Type", ar: "النوع" },
    batteryChangedAt: { en: "Changed At", ar: "تاريخ التغيير" },

    filtersSection: { en: "Filters", ar: "الفلاتر" },

    damages: { en: "Damage Notes", ar: "ملاحظات الأضرار" },

    cancel: { en: "Cancel", ar: "إلغاء" },
    save: { en: "Save", ar: "حفظ" },

    required: { en: "This field is required", ar: "هذا الحقل مطلوب" },
  };

  const t = (key) => labels[key]?.[language];

  const validate = () => {
    const e = {};
    if (!formData.user) e.user = t("required");
    if (!formData.vehicle_type) e.vehicle_type = t("required");
    if (!formData.vehicle_model) e.vehicle_model = t("required");
    if (!formData.vehicle_year) e.vehicle_year = t("required");
    if (!formData.vehicle_number) e.vehicle_number = t("required");
    //  if (!formData.vehicle_brand_id.length) e.vehicle_brand_id = t("required");

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleChange = (k, v) => {
    setFormData((p) => ({ ...p, [k]: v }));
    setErrors((p) => ({ ...p, [k]: "" }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4">
      <div className="bg-card w-full max-w-3xl max-h-[90vh] overflow-y-auto rounded-xl">
        {/* HEADER */}
        <div className="flex justify-between p-4 border-b">
          <h2>{mode === "add" ? t("addTitle") : t("editTitle")}</h2>
          <button onClick={onClose}>
            <Icon name="X" />
          </button>
        </div>

        <form
          className="p-4 space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
         //   if (validate()) 
              onSave(formData);
          }}
        >
          {/* USER */}
          <Select
            label={t("user")}
            options={usersList?.map((u) => ({
              value: u.enc_id,
              label: u.first_name,
            }))}
            value={formData.user_id}
            onChange={(v) => handleChange("user_id", v)}
            error={errors.user_id}
          />

          {/* CAR TYPE */}
          <Input
            label={t("vehicle_type")}
            value={formData.vehicle_type}
            onChange={(e) => handleChange("vehicle_type", e.target.value)}
            error={errors.vehicle_type}
          />

          {/* vehicle_model */}
          <Input
            label={t("vehicle_model")}
            value={formData.vehicle_model}
            onChange={(e) => handleChange("vehicle_model", e.target.value)}
            error={errors.vehicle_model}
          />

          {/* vehicle_year */}
          <Input
            type="number"
            label={t("vehicle_year")}
            value={formData.vehicle_year}
            onChange={(e) => handleChange("vehicle_year", e.target.value)}
            error={errors.vehicle_year}
          />

          {/* LICENSE */}
          <Input
            label={t("vehicle_number")}
            value={formData.vehicle_number}
            onChange={(e) =>
              handleChange("vehicle_number", e.target.value.toUpperCase())
            }
            error={errors.vehicle_number}
          />

          {/* vehicle_brand_id */}

            <Select
            label={t("vehicle_brand_id")}
            options={tagsList?.map((u) => ({
              value: u.id,
              label: u.name,
            }))}
           value={formData.vehicle_brand_id}
            onChange={(v) => handleChange("vehicle_brand_id", v)}
            error={errors.vehicle_brand_id}
          />
        

          {/* EXTRA */}
          <Input
            label={t("vehicleColor")}
            value={formData.vehicle_color}
            onChange={(e) => handleChange("vehicle_color", e.target.value)}
          />

          <Input
            label={t("notes")}
            value={formData.notes}
            onChange={(e) => handleChange("notes", e.target.value)}
          />

          {/* OIL */}
          <h3>{t("oilSection")}</h3>

          <Input
            label={t("oilName")}
            value={formData.oil_name}
            onChange={(e) => handleChange("oil_name", e.target.value)}
          />

          <Input
            label={t("oilRank")}
            value={formData.oil_rank}
            onChange={(e) => handleChange("oil_rank", e.target.value)}
          />

          <Input
            type="number"
            label={t("oilMeter")}
            value={formData.oil_meter_value}
            onChange={(e) => handleChange("oil_meter_value", e.target.value)}
          />

          <Input
            type="date"
            label={t("oilChangedAt")}
            value={formData.oil_changed_at}
            onChange={(e) => handleChange("oil_changed_at", e.target.value)}
          />

          {/* TIRE */}
          <h3>{t("tireSection")}</h3>

          <Input
            label={t("tireName")}
            value={formData.tire_name}
            onChange={(e) => handleChange("tire_name", e.target.value)}
          />

          <Input
            label={t("tireType")}
            value={formData.tire_type}
            onChange={(e) => handleChange("tire_type", e.target.value)}
          />

          {/* BATTERY */}
          <h3>{t("batterySection")}</h3>

          <Input
            label={t("batteryType")}
            value={formData.battery_type}
            onChange={(e) => handleChange("battery_type", e.target.value)}
          />

          {/* DAMAGES */}
          <Input
            label={t("damages")}
            value={formData.damages_note}
            onChange={(e) => handleChange("damages_note", e.target.value)}
          />

          {/* BUTTONS */}
          <div className="flex gap-3 pt-4">
            <Button type="button" variant="outline" onClick={onClose}>
              {t("cancel")}
            </Button>
            <Button loading={isLoadingActions} type="submit">{t("save")}</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserCarsFormModal;
